import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { groupsScreen } from '@/ui/pages/Groups/groupsScreen';

/**
 * HS-869: the list is a `@smartsash/data-screen` definition, so the route no longer takes the
 * permissive `passthroughSearch` — `page`, `pageSize`, `q`, `sort` and `filters` are validated by
 * the entity's own schema, the loader prefetches into the same cache the screen suspends on, and
 * `loaderDeps` re-runs it only when a parameter the server actually receives changes.
 *
 * The screen component is bound to a local identifier because `autoCodeSplitting` moves
 * `component` into a virtual module, and its compiler only accepts an identifier, a call, a
 * conditional, or an `as` expression — a member expression such as `groupsScreen.ListScreen`
 * fails the build with `Unexpected splitNode type: MemberExpression`.
 */
const GroupsListScreen = groupsScreen.ListScreen;

export const Route = createFileRoute('/_dashboard/groups/')({
  validateSearch: groupsScreen.validateSearch,
  loaderDeps: groupsScreen.loaderDeps,
  beforeLoad: requireRoute('/groups'),
  loader: groupsScreen.loaderFor(),
  component: GroupsListScreen,
});
